export default __webpack_public_path__ + "static/media/scroll-arrow.2d0fcf50.svg";